
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ListCheckPipe } from './filtros-pipes/list-check.pipe';
import { InnerHtmlPipe } from './innerHtml/innerHtml.pipe';
import { FormatDatePipe } from './formatDate/formatDate.pipe';
import { IntPipe } from './int/int.pipe';
import { GetDatosUsuarioPipe } from './usuarioPedido/get-datos-usuario.pipe';
import { PermisoPipe } from './permisoPedido/permiso.pipe';
@NgModule({
  declarations: [
    ListCheckPipe,
    InnerHtmlPipe,
    FormatDatePipe,
    IntPipe,
    GetDatosUsuarioPipe,
    PermisoPipe
   ],
  imports: [
    CommonModule
  ],
  exports: [
    ListCheckPipe,
    InnerHtmlPipe,
    FormatDatePipe,
    IntPipe,
    GetDatosUsuarioPipe,
    PermisoPipe
  ]

})
export class PipesCoreModule { }
